<template>
  <div id="app">
    <TopBar/>
    <AppHeader v-if="$route.meta.useAppHeader"></AppHeader>
    <router-view/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import identify from '@/lib/track/identify';

export default {
  name: 'app',
  created() {
    this.authorize();
    this.track();
  },
  computed: mapGetters(['user', 'team']),
  watch: {
    user() {
      this.track();
    }
  },
  methods: {
    ...mapActions(['authorize', 'waitForTeam']),
    async track() {
      if (!this.user) return;
      await this.waitForTeam();
      identify(this.user, this.team);
    }
  },
}
</script>

<style lang="scss">
  @import 'scss/main';
  @import '~scss/colors';

  #app {
    height: 100%;
    overflow-x: hidden;
  }

  /* app css */

  header{
    background-color: $white;
  }

  body {
    // Force scrolling to be smooth on iOS
    -webkit-overflow-scrolling: touch;

    height: 100%;
    font-size: 18px;
    font-family: "Proxima Nova", sans-serif;
  }

  img {
    border: 0;
  }

  ul {
    list-style: disc outside none;
    margin:0;
    padding:0;
}

li{
    margin:0;
    padding:0;
}

  * {
    box-sizing: border-box;
  }

  #alert{
  border-radius: 5px;
  background-color: #f1f8e8;
  font-size:14px;
  color:$alert-green;
  border: 1px $alert-green solid;

  .alert-link{
    color:$alert-link-blue;
    font-weight: 700;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue